import { GlobalOutlined } from '@ant-design/icons';
import { getLocale, setLocale } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import React, { useCallback, useMemo } from 'react';

/**
 * Customized language dropdown limited to supported locales.
 * Uses antd v6 `menu` API to avoid overlay-only child issues.
 */
const CustomizedLangDropdown: React.FC = () => {
  const currentLocale = getLocale();

  const locales = useMemo(
    () => [
      { key: 'en-US', label: 'English' },
      { key: 'ar-EG', label: 'العربية' },
    ],
    [],
  );

  const languageItems: MenuProps['items'] = useMemo(
    () =>
      locales.map((locale) => ({
        key: locale.key,
        label: (
          <Space size={8}>
            <span>{locale.label}</span>
          </Space>
        ),
      })),
    [locales],
  );

  const handleMenuClick = useCallback<Required<MenuProps>['onClick']>(
    ({ key }) => {
      if (key && key !== currentLocale) {
        setLocale(String(key), false);
      }
    },
    [currentLocale],
  );

  const menuProps = useMemo<MenuProps>(
    () => ({
      selectedKeys: [currentLocale],
      items: languageItems,
      onClick: handleMenuClick,
    }),
    [currentLocale, handleMenuClick, languageItems],
  );

  return (
    <Dropdown trigger={['hover']} placement="bottomRight" menu={menuProps}>
      <span
        style={{
          padding: 8,
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <GlobalOutlined />
      </span>
    </Dropdown>
  );
};

export default CustomizedLangDropdown;
